import { createAction, props } from "@ngrx/store";
import { IMaxxOptimizerQueryDto } from "@core/models/http/treatment/treatment-plans/optimizer-dto";
import { TreatmentConfigurationDto } from "../../../../core/models/http/treatment/treatment-configuration-dto";
import { TreatmentContractDto } from "../../../../core/models/http/treatment/treatment-contract-dto";
import { TreatmentPlanBenefitDto } from "../../../../core/models/http/treatment/treatment-plan-benefits/treatment-plan-benefit-dto";
import { TreatmentNotificationDto } from "../../../../core/models/http/treatment/notifications/treatment-notification-dto";
import { TreatmentPlanDto } from "../../../../core/models/http/treatment/treatment-plans/treatment-plan-dto";
import { UpdateFee } from "../fees/models/update-fee";
import { UpdateLineItem } from "../line-items/update-line-item";
import { TreatmentPlanAction } from "../treatment-plan-action";
import { ExpenseFee } from "../fees/models/expense-fee";
import { TreatmentCourtesy } from "../courtesies/models/courtesy";
import { InsurancePolicyBenefitOverridden } from "../../../../core/models/http/treatment/insurance-policy-benefits/insurance-policy-benefit-overridden";
import { UpdateCourtesy } from "../courtesies/models/update-courtesy";
import { InsurancePolicyBenefit } from "../insurance-policy-benefits/insurance-policy-benefit";

export const loadSuccess = createAction(
  "[TreatmentPlan API] Load Success",
  props<{ contract: TreatmentContractDto }>()
);

export const loadConfigurationSuccess = createAction(
  "[TreatmentPlan API] Load Configuration Success",
  props<{ configuration: TreatmentConfigurationDto }>()
);

/**
 * The HTTP call to the validate endpoint responded. **This does not necessarily
 * mean the contract was validated successfully**. If the contract is invalid,
 * any validation errors will be processed by the reducer.
 */
export const validateContractSuccess = createAction(
  "[TreatmentPlan API] Validate Contract Success",
  props<{ validationErrors: string[] }>()
);

export const loadBenefitSuccess = createAction(
  "[TreatmentPlan API] Load Benefit Success",
  props<{ benefits: TreatmentPlanBenefitDto[] }>()
);

export const addBenefitSuccess = createAction(
  "[TreatmentPlan API] Add Benefit Success",
  props<{ insurancePolicyBenefit: InsurancePolicyBenefit }>()
);

export const saveNetworkDiscountSuccess = createAction(
  "[TreatmentPlan API] Save Network Discount Success",
  props<TreatmentPlanAction>()
);
export const loaded = createAction("[Treatment API] Loaded");
export const loadNotificationsSuccess = createAction(
  "[TreatmentPlan API] Load Notifications Success",
  props<{ notifications: TreatmentNotificationDto[] }>()
);

export const calculateSuccess = createAction(
  "[TreatmentPlan API] Calculate Success",
  props<{ benefit: TreatmentPlanBenefitDto }>()
);

export const saveDiagnosisCodeSuccess = createAction(
  "[TreatmentPlan API] Save Diagnosis Code Success"
);

export const saveAcceledentSuccess = createAction(
  "[TreatmentPlan API] Save Acceledent Success"
);

export const saveNameSuccess = createAction(
  "[TreatmentPlan API] Save Name Success"
);

export const savePatientExamSuccess = createAction(
  "[TreatmentPlan API] Save Patient Exam Success"
);

export const saveTreatmentLengthSuccess = createAction(
  "[TreatmentPlan API] Save Treatment Length Success",
  props<TreatmentPlanAction>()
);

export const removeTreatmentPlanSuccess = createAction(
  "[TreatmentPlan API] Remove Treatment Plan Success"
);

export const removeCourtesySuccess = createAction(
  "[TreatmentPlan API] Remove Courtesy Success",
  props<TreatmentPlanAction>()
);

export const updateCourtesySuccess = createAction(
  "[TreatmentPlan API] Update Courtesy Success",
  props<{ courtesyId: string; treatmentPlanId: number }>()
);

export const benefitSaveSuccess = createAction(
  "[TreatmentPlan API] Benefit Save Success",
  props<{ insurancePolicyId: number; treatmentPlanId: number }>()
);

export const aobSaveSuccess = createAction(
  "[TreatmentPlan API] AOB Save Success",
  props<{
    insurancePolicyId: number;
    timestamp: Date;
  }>()
);

export const insuranceTimestampLoadSuccess = createAction(
  "[TreatmentPlan API] Insurance Timestamp Load Success",
  props<{ timestamp: Date }>()
);

export const removeExpenseSuccess = createAction(
  "[TreatmentPlan API] Remove Expense Success",
  props<TreatmentPlanAction>()
);

export const updateFeeSuccess = createAction(
  "[TreatmentPlan API] Update Fee Success",
  props<UpdateFee>()
);

export const createTreatmentPlanSuccess = createAction(
  "[TreatmentPlan API] Create Treatment Plan Success",
  props<{ originalId: number; treatmentPlan: TreatmentPlanDto }>()
);

export const createExpenseFeeSuccess = createAction(
  "[TreatmentPlan API] Create Expense Fee Success",
  props<{ feeId: string; treatmentPlanId: number }>()
);

export const createCourtesySuccess = createAction(
  "[TreatmentPlan API] Create Courtesy Success",
  props<{ courtesyId: string; treatmentPlanId: number }>()
);

export const updateLineItemSuccess = createAction(
  "[Treatment Plan API] Update Line Item Success",
  props<UpdateLineItem>()
);

export const createTreatmentPlanOptimizerSuccess = createAction(
  "[TreatmentPlan API] Create iMaxX Treatment Plan Success",
  props<{ originalId: number; imaxxOptimized: IMaxxOptimizerQueryDto }>()
);
